import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import DatePicker from "react-datepicker"

import ReactSelect from 'pages/parts/ReactSelect'
import useDidMountEffect from 'pages/parts/useDidMountEffect'
import { httpOk, GET, POST } from 'helpers/api'
import { handleDecimalKeyDown } from 'helpers/decimalKey'
import { formatMoney, formatDate, returnMinDate, notify } from 'helpers/helpers'

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const [data, setData] = useState({
		"products": [],
		"note": '',
		"total_amount": 0,
		"created_at": formatDate(new Date(), 'yyyy-MM-dd'),
	})
	const [addQuantity, setAddQuantity] = useState(1)
	const [wms, setWms] = useState([])
	const [toWms, setToWms] = useState([])
	const [products, setProducts] = useState([])
	const [productsDuplicate, setProductsDuplicate] = useState([])

	async function createUpdate(e) {
		e.preventDefault();

		var dataCopy = { ...data }
		dataCopy.error = false

		if (!dataCopy.products.length) {
			notify(t('add_elements'))
			return
		}

		for (let i = 0; i < dataCopy.products.length; i++) {
			if (!dataCopy.products[i]['quantity']) {
				dataCopy.error = true
			}

			if (Number(dataCopy.products[i]['quantity']) > Number(dataCopy.products[i]['wms_balance'])) {
				dataCopy.error = true
			}
		}

		var valueArr = dataCopy.products.map(function (item) { return item.product_id });
		var isDuplicate = valueArr.some(function (item, idx) {
			return valueArr.indexOf(item) !== idx
		});

		if (isDuplicate) {
			notify(t('identical_elements'))
			return
		}

		const response = await POST('/wms-transfer', dataCopy, { loader: true })

		if (httpOk(response)) navigate('/wms-transfer-wms')
	}

	function addToList(length = 1) {
		var dataCopy = JSON.parse(JSON.stringify(data))

		for (let i = 0; i < length; i++) {
			dataCopy.products.push({
				'product_id': '',
				'quantity': '',
				'cost_price': '',
				'total_price': '',
			})
		}

		countTotalAmount(dataCopy)

		setTimeout(() => {
			const byId = document.getElementById(`input-select-${dataCopy.products.length}`)
			byId?.select()
		}, 200);
	}

	function deleteItem(index) {
		var dataCopy = JSON.parse(JSON.stringify(data))
		dataCopy.products.splice(index, 1)

		setData(dataCopy)
	}

	function countTotalAmount(dataCopy) {
		dataCopy.total_amount = 0

		for (let i = 0; i < dataCopy.products.length; i++) {
			dataCopy.total_amount += Number(dataCopy.products[i]['quantity']) * Number(dataCopy.products[i]['cost_price'])
			dataCopy.products[i]['total_price'] = Number(dataCopy.products[i]['quantity']) * Number(dataCopy.products[i]['cost_price'])
		}

		setData(dataCopy)
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }

		dataCopy.products[index][e.target.name] = e.target.value
		countTotalAmount(dataCopy)
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (value === '+' || value === '=') return
		if (!value || value === '+' || value === '=') {
			setProducts([...productsDuplicate])
			return
		}
		var productsDuplicateCopy = [...productsDuplicate]

		var filteredItems = productsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setProducts(filteredItems)
	}

	function handleSelectProduct(option, index) {
		var dataCopy = { ...data }

		dataCopy.products[index]['product_id'] = option.id
		dataCopy.products[index]['name'] = option.name
		dataCopy.products[index]['balance'] = option.balance
		dataCopy.products[index]['cost_price'] = option.cost_price
		dataCopy.products[index]['unit_name'] = option.unit_name

		setData(dataCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var productsCopy = [...products]

			for (let i = 0; i < productsCopy.length; i++) productsCopy[i]['selected'] = false

			if (productsCopy[0] && productsCopy[0]['selected']) productsCopy[0]['selected'] = true

			setProducts(productsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = products.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var productsCopy = [...products]
			productsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						productsCopy[products.length - 1].selected = true
						currentIndex = products.length - 1
					} else {
						productsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === products.length - 1) {
						productsCopy[0].selected = true
						currentIndex = 0
					} else {
						productsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setProducts(productsCopy)
		}
	}
	// REACTSELECT LOGIC

	async function getWms() {
		const response = await GET(`/helper/wms`, {}, { loader: true })

		if (httpOk(response)) setWms(response.data)
	}

	async function getProducts() {
		if (!data.from_wms_id) return

		const response = await GET(`/wms-transfer-products?from_wms_id=${data.from_wms_id}`, {}, { loader: true })

		if (httpOk(response)) {
			setProducts(response.data)
			setProductsDuplicate(response.data)
		}
	}

	useEffect(() => {
		getWms()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		getProducts(data.from_wms_id)
	}, [data.from_wms_id]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('transfer')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											yearDropdownItemNumber={2}
											disabled
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), 20)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('from_warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.from_wms_id)}
										onChange={(option) => {
											setData({ ...data, 'from_wms_id': option.id })
											setToWms(wms.filter(item => item.id !== option.id))
										}}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('to_warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={toWms}
										value={toWms.find(option => option.id === data.to_wms_id)}
										onChange={(option) => setData({ ...data, 'to_wms_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control" name="note"
										value={data.note}
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="card">
					<div className="card-body">
						<div className="table-responsive">
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '30%' }}>{t('name2')}</th>
										<th style={{ 'width': '20%' }} className="text-end">{t('balance2')}</th>
										<th style={{ 'width': '10%' }} className="text-start">{t('unit')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('cost_price')}</th>
										<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
										<th style={{ 'minWidth': '33px' }} className="text-center"></th>
									</tr>
								</thead>
								<tbody>
									{data.products.map((item, index) => (
										<tr key={index}>
											<td className="text-center">{index + 1}</td>
											<td>
												<ReactSelect
													uniqueId="select"
													search={handleSelectSearch}
													value={item.name}
													index={index}
													scrollRef={scrollRef}
													options={products}
													onClose={() => closeReactSelect()}
													selectItem={(option) => handleSelectProduct(option, index)}
													onKeyUp={(e) => {
														if (e.keyCode === 40 || e.keyCode === 38) {
															handleTableKeyDown(e)
														}
													}}
													table={
														<table className="table mb-0">
															<tbody ref={tbodyRef}>
																{products.map((selectItem, selectIndex) => (
																	<tr
																		id={selectItem.id}
																		className={`cursor ${((selectItem.selected || selectItem.id === item.product_id) && 'selected')}`}
																		tabIndex={-1}
																		key={selectIndex}
																		onClick={() => handleSelectProduct(selectItem, index)}
																		onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																		<td>{selectItem.name}</td>
																		<td>{selectItem.product_type_name}</td>
																		<td className="text-end text-nowrap">{formatMoney(selectItem.cost_price)}</td>
																	</tr>
																))}
															</tbody>
														</table>
													}
												/>
											</td>
											<td className="text-end vertical-middle">
												{formatMoney(item.balance, 2)}
											</td>
											<td className="text-start vertical-middle">
												{item.unit_name}
											</td>
											<td className="td-input">
												<input type="number" className="form-control text-end"
													name="quantity"
													value={item.quantity}
													onChange={(e) => handleInputChange(e, index)}
													onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))}
													onKeyUp={(event) => {
														if (event.key === 'Enter') {
															addToList()
														}
													}} />
											</td>
											<td className="text-end vertical-middle">
												{formatMoney(item.cost_price)}
											</td>
											<td className="text-end vertical-middle">
												{formatMoney(item.total_price)}
											</td>
											<td className="vertical-middle">
												<div className="d-flex justify-content-center">
													<div className="table-action-button table-action-danger-button"
														onClick={() => deleteItem(index)}>
														<i className="uil uil-times"></i>
													</div>
												</div>
											</td>
										</tr>
									))}
									<tr>
										<td className="td-input">
											<input
												type="text"
												className="form-control text-center"
												style={{ 'padding': '5px 0' }}
												placeholder="xxx"
												value={addQuantity}
												onChange={(e) => setAddQuantity(e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, ''))}
											/>
										</td>
										<td colSpan={1} style={{ 'padding': 0 }}>
											<div className="d-flex">
												<div className="w-100">
													<button type="button" className="btn-sm btn-primary w-100"
														disabled={!data.from_wms_id}
														onClick={() => {
															setAddQuantity(1)
															addToList(addQuantity)
														}}>
														{t('add')}
													</button>
												</div>
											</div>
										</td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end vertical-middle">
											<b>{formatMoney(data.total_amount)}</b>
										</td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="btn-wrapper gap-2">
							<Link className="btn btn-warning btn-rounded btn-wide" to="/service/wms-transfer-pos" tabIndex="-1">
								{t('cancel')}
							</Link>
							<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
								onClick={createUpdate}>
								{t('confirm')}
							</button>
						</div>
					</div>
				</div>
			</form>
		</>
	)
}

export default CreateUpdate